import React from 'react';
import propTypes from 'prop-types';
import * as tripHelper from '../../../helpers/trip';
import * as ticketAction from '../../../store/actions/ticket';
import {LoadingSection} from '../../../components/Loading';
import {
  isLoading,
  FAILURE
} from '../../../utils/status';

import './index.css';

import {connect} from 'react-redux';
import * as navigator from '../../../native/navigator';
import { sendStatsEvent } from '../../../components/statistics/index';


class LocalAttraction extends React.Component {
  static propTypes = {
    trip: propTypes.object.isRequired,
    day: propTypes.number.isRequired,
    getRecommended: propTypes.func.isRequired,
    recommendedTicket: propTypes.object,
    status: propTypes.string
  };

  render() {
    let {recommendedTicket, status} = this.props;

    if (isLoading(status, true)) {
      return (<LoadingSection />);
    }

    if (status === FAILURE) {
      return null;
    }

    if (!recommendedTicket.list.length) {
      return null;
    }

    let listView = recommendedTicket.list.map(function (ticket) {
      let key = ticket.goods_id + '';
      return (<Attraction key={key} ticket={ticket} />);
    });

    listView.push(
      <More
        key={recommendedTicket.more_link}
        link={recommendedTicket.more_link} />
    );

    return (
      <section className='local-attraction'>
        <div className='section-title'><h2>当地玩乐</h2></div>
        <div className='content'>
          <ul>{listView}</ul>
        </div>
      </section>
    );
  }

  componentDidMount() {
    this.fetchTickets(this.props);
  }

  componentWillReceiveProps(nextProps) {
    let props = this.props;

    if (props.day !== nextProps.day) {
      this.fetchTickets(nextProps);
    }
  }

  fetchTickets(props) {
    let {day, trip, getRecommended} = props;
    let cities, pois;

    if (day > 0) {
      cities = tripHelper.getCitiesOfDayTrip(trip, day);
      pois = tripHelper.getPois(trip, day);
    } else {
      cities = tripHelper.getCities(trip);
      pois = tripHelper.getPois(trip);
    }

    let cityIds = cities ? cities.map(function (city) {
      return city.city;
    }).join(',') : '';
    let poiUids = pois.map(function (poi) {
      return poi.poi_uid;
    }).join(',') || '';

    getRecommended(cityIds, poiUids);
  }
}


function More(props) {
  return (
    <li className='more'>
      <a onClick={() => {
        sendStatsEvent('trip_Ticketsmore_click');
        navigator.push(props.link);
      }}>
        <div className='center'>
          <span className='arrow'><i className='icon icon-arrow' /></span>
          <span className='text'>查看更多</span>
        </div>
      </a>
    </li>
  );
}


function Attraction(props) {
  let {ticket} = props;

  return (
    <li className='attraction'>
      <a onClick={() => {
        sendStatsEvent('trip_Tickets_click');
        navigator.push(ticket.goods_link);
      }}>
        <div className='pic' style={{backgroundImage: `url(${ticket.img})`}} />

        <div className="description">
          <p className="title">{ticket.title}</p>
          <div className="price">
            <strong>￥{ticket.price}</strong>
            <span>省{ticket.delete_price - ticket.price}元</span>
          </div>
          <div className="other-message">
            <div className="other-price">市场价<small>￥{ticket.delete_price}</small></div>
            <div className="sales-volume">{ticket.sales_volume}人玩过</div>
          </div>
        </div>
      </a>
    </li>
  );
}


export default connect(function (state, ownProps) {
  return {
    ...ownProps,
    recommendedTicket: state.ticket.recommended.data,
    status: state.ticket.recommended.status
  };
}, ticketAction)(LocalAttraction);



// WEBPACK FOOTER //
// ./src/pages/trip/LocalAttraction/index.js